import { render, staticRenderFns } from "./UiMessage.vue?vue&type=template&id=4544116c&scoped=true"
import script from "./UiMessage.vue?vue&type=script&lang=js"
export * from "./UiMessage.vue?vue&type=script&lang=js"
import style0 from "./UiMessage.vue?vue&type=style&index=0&id=4544116c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544116c",
  null
  
)

export default component.exports